import styled from 'styled-components/macro'
import { COLORS, FLEX_CONTAINER } from 'utils/styles'

export const StyledModalContainer = styled.div`
  ${FLEX_CONTAINER.FlexColumn}
  gap:24px;
  overflow: scroll;
  width: 350px;
  height: 600px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar{
    display: none
  }

  @media (max-width: 768px) {
    height: 550px
  }

  @media (max-width: 1900px) and (max-height: 800px) {
    height: 460px
  }

  @media (max-width: 1900px) and (max-height: 721px) {
    height: 310px
  }

  @media (max-width: 1900px) and (max-height: 500px) {
    height: 180px
  }

  @media (max-width: 1000px) and (max-height: 700px) {
    height: 310px
  }

  @media (max-width: 1000px) and (max-height: 500px) {
    height: 220px
  }

  /* Mobile or Tablet */
  @media (max-width: 800px) and (max-height: 400px) {
    height: 70svh
  }

  @media (max-width: 700px) and (max-height: 500px) {
    height: 70svh
  }
  
  @media (max-width: 480px) and (max-height: 700px) {
    width: 300px;
    height: 70svh;
  }

  @media (max-width: 370px) and  (max-height: 700px) {
    width: 300px;
    height: 70svh;
  }
  
`

export const StyledUserProfileContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  align-items: center;
  position: relative;
`

export const StyledCopiedContainer = styled.div`
  width: max-content;
  padding: 3px 6px 0px;
  background-color: ${COLORS.gold};
  border-radius: 5px;
`

export const StyledCopyIcon = styled.div`
  cursor: pointer;
`

export const StyledUserName = styled.div`
  font-size: 16px;
  letter-spacing: 0.07em;
`

export const StyledUserLastAccessed = styled.div`
  font-size: 12px;
  letter-spacing: 0.07em;
  color: ${COLORS.darkGray};
`

export const StyledConnectionsContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
`

export const StyledConnectionsContent = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  align-items: center;
`

export const StyledContentTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: ${COLORS.darkGray};
`

export const StyledContentText = styled.div`
  font-weight: 600;
  font-size: 24px;
  color: ${COLORS.black};
`

export const StyledContentImage = styled.img`
  width: 28px;
  height: 28px;
`

export const StyledWordsTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  color: ${COLORS.black};
  margin: 0 20px;
`

export const StyledFlexContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  gap:16px;
  flex-wrap: wrap;
  margin: 0 20px;
`

export const StyledWordsContent = styled.div`
  padding: 6px 24px;
  background: ${COLORS.semiLightGray};
  border-radius: 50px;
`
